"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
const LengthRule = require("../LengthRule");
exports.builder = {
    withLength: (length, errorMessage) => ({
        type: LengthRule.NAME,
        length,
        errorMessage,
    }),
};
//# sourceMappingURL=LengthRuleBuilder.js.map